"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = exports.JavaScriptObfuscator = void 0;
require("reflect-metadata");
const ServiceIdentifiers_1 = require("./container/ServiceIdentifiers");
const ApiError_1 = require("./pro-api/ApiError");
const InversifyContainerFacade_1 = require("./container/InversifyContainerFacade");
const Options_1 = require("./options/Options");
const Utils_1 = require("./utils/Utils");
const ProApiClient_1 = require("./pro-api/ProApiClient");
class JavaScriptObfuscatorFacade {
    static obfuscate(sourceCode, inputOptions = {}) {
        const inversifyContainerFacade = new InversifyContainerFacade_1.InversifyContainerFacade();
        inversifyContainerFacade.load(sourceCode, '', inputOptions);
        const javaScriptObfuscator = inversifyContainerFacade.get(ServiceIdentifiers_1.ServiceIdentifiers.IJavaScriptObfuscator);
        const obfuscationResult = javaScriptObfuscator.obfuscate(sourceCode);
        inversifyContainerFacade.unload();
        return obfuscationResult;
    }
    static obfuscateMultiple(sourceCodesObject, inputOptions = {}) {
        if (typeof sourceCodesObject !== 'object') {
            throw new Error('Source codes object should be a plain object');
        }
        return Object.keys(sourceCodesObject).reduce((acc, sourceCodeIdentifier, index) => {
            const identifiersPrefix = Utils_1.Utils.getIdentifiersPrefixForMultipleSources(inputOptions.identifiersPrefix, index);
            const sourceCode = sourceCodesObject[sourceCodeIdentifier];
            const sourceCodeOptions = {
                ...inputOptions,
                identifiersPrefix
            };
            return {
                ...acc,
                [sourceCodeIdentifier]: JavaScriptObfuscatorFacade.obfuscate(sourceCode, sourceCodeOptions)
            };
        }, {});
    }
    static getOptionsByPreset(optionsPreset) {
        return Options_1.Options.getOptionsByPreset(optionsPreset);
    }
    static async obfuscatePro(sourceCode, inputOptions, proApiConfig, onProgress) {
        if (!inputOptions.vmObfuscation) {
            throw new ApiError_1.ApiError('obfuscatePro method works only with VM obfuscation. Set vmObfuscation: true in options.', 400);
        }
        const client = new ProApiClient_1.ProApiClient(proApiConfig);
        return client.obfuscate(sourceCode, inputOptions, onProgress);
    }
}
exports.JavaScriptObfuscator = JavaScriptObfuscatorFacade;
JavaScriptObfuscatorFacade.version = (_a = process.env.VERSION) !== null && _a !== void 0 ? _a : 'unknown';
var ApiError_2 = require("./pro-api/ApiError");
Object.defineProperty(exports, "ApiError", { enumerable: true, get: function () { return ApiError_2.ApiError; } });
